import React, { useState } from 'react';

interface GoogleClassroomImportButtonProps {
  onImportClick: () => void;
  className?: string;
}

const GoogleClassroomImportButton: React.FC<GoogleClassroomImportButtonProps> = ({ onImportClick, className = '' }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleImportClick = () => {
    setIsLoading(true);
    onImportClick();
    setIsLoading(false);
  };

  const getButtonContent = () => {
    if (isLoading) {
      return (
        <div className="flex py-1">
          <span>Loading...</span>
        </div>
      );
    }

    return (
      <div className="flex py-1">
        <span>Import from Google Classroom</span>
      </div>
    );
  };

  const getButtonStyle = () => {
    return 'bg-secondaryStoryLightGrayButtonBackground border-secondaryStoryLightGrayButtonBackground text-secondaryStoryGrayButtonText hover:shadow rounded-lg hover:bg-secondaryStoryLightGrayButtonBackgroundHover hover:border-secondaryStoryLightGrayButtonBackgroundHover';
  };

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={handleImportClick}
        disabled={isLoading}
        className={`w-full border font-semibold py-1 px-3 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2 ${getButtonStyle()} ${className} ${
          isLoading ? 'opacity-50 cursor-not-allowed' : ''
        }`}
      >
        {getButtonContent()}
      </button>
    </div>
  );
};

export default GoogleClassroomImportButton;
